import { useState, useEffect, useCallback } from 'react';
import { visitsApi } from '../services/visitsApi';

export const useTodaysVisits = () => {
  const [visits, setVisits] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchTodaysVisits = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await visitsApi.getTodaysVisits();
      
      // Handle different possible response structures
      let visitsData = [];
      
      if (Array.isArray(response)) {
        visitsData = response;
      } else if (response && response.data && Array.isArray(response.data)) {
        visitsData = response.data;
      } else if (response && response.visits && Array.isArray(response.visits)) {
        visitsData = response.visits;
      }
      
      setVisits(visitsData);
    } catch (err) {
      setError(err.message || 'Failed to fetch today\'s visits');
      setVisits([]);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchTodaysVisits();
  }, [fetchTodaysVisits]);

  const refetch = () => {
    fetchTodaysVisits();
  };

  return {
    visits,
    loading,
    error,
    refetch,
  };
};